import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/users";

export const BULK_UPLOAD_ENDPOINT = `${BASE}/bulk-upload`;

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function lookup({ email } = {}) {
  return axios.post(`${BASE}/lookup`, { email });
}

export function checkUser() {
  return axios.get(`${BASE}/check-user`);
}

export function saveDetails(data) {
  return axios.post(`${BASE}/save-details`, data);
}

export function update(id, { field, value }) {
  return axios.patch(`${BASE}/${id}`, { field, value });
}

export function updateListStatus(id, { blackListed, greyListed, reason }) {
  return axios.patch(`${BASE}/${id}/list-status`, {
    blackListed,
    greyListed,
    reason,
  });
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}
